<template>

  <div class="elevation-4">
    <v-toolbar flat="flat">
      <v-toolbar-title>Regions</v-toolbar-title>
    </v-toolbar>
    <TreeView :items="regions" childname="subregions">
      <template slot="item" slot-scope="props">
        <td class="region-link">
          <div class="name">{{ props.item.name }} ( {{ props.item.id }} )</div>
        </td>
      </template>
    </TreeView>
  </div>

</template>

<script>

import RegionLink from '@/components/links/Region'
import TreeView from '@/components/common/TreeView'

export default {
  name: 'FederationRegions',
  components: {
    RegionLink,
    TreeView
  },
  props: ['regions']
}

</script>



// WEBPACK FOOTER //
// src/pages/federation/FederationRegions.vue